import React, { Component } from 'react'
import { connect } from 'react-redux'
// import Modal from 'react-bootstrap/lib/Modal'
import ModalHeader from './ModalHeader'
import { processEditedData } from '../../actions/Edit'
import { injectIntl, FormattedMessage } from 'react-intl'
import Loader from '../Loader'
import _ from 'underscore'
import moment from 'moment'
import { sendTrackingData } from '@vmockinc/dashboard/services/tracking'
import { Modal, ModalBody } from '@vmockinc/dashboard/Common/commonComps/Modal'
import FocusLock, { MoveFocusInside } from 'react-focus-lock'
import { logModalAriaLabel } from '../Constants/AriaLabelText'
import { downloadImage } from '../../actions/ImageUpload'



class LogScreen extends Component {
  constructor(props) {
    super(props)
    this.state = {
      currentLogSection: 'Profile Picture',
    }
    this.sendTrackingDataDebounce = _.debounce(sendTrackingData, 2000, true)
    this.compareDatesInLogObject = this.compareDatesInLogObject.bind(this)
    this.downloadImage = this.downloadImage.bind(this)
    this.month = {
      '01': 'January',
      '02': 'February',
      '03': 'March',
      '04': 'April',
      '05': 'May',
      '06': 'June',
      '07': 'July',
      '08': 'August',
      '09': 'September',
      10: 'October',
      11: 'November',
      12: 'December',
    }

    this.monthKeyMap = {
      '01': 'aspire.experience.monthJanuary',
      '02': 'aspire.experience.monthFebruary',
      '03': 'aspire.experience.monthMarch',
      '04': 'aspire.experience.monthApril',
      '05': 'aspire.experience.monthMay',
      '06': 'aspire.experience.monthJune',
      '07': 'aspire.experience.monthJuly',
      '08': 'aspire.experience.monthAugust',
      '09': 'aspire.experience.monthSeptember',
      '10': 'aspire.experience.monthOctober',
      '11': 'aspire.experience.monthNovember',
      '12': 'aspire.experience.monthDecember',
    }

    this.sectionUnderscore = {
      'Personal Information': 'personal_information',
      'Profile Picture': 'profile_picture',
      Headline: 'headline',
      Summary: 'summary',
      Experience: 'experience',
      Education: 'education',
    }

    this.leftNavIconsMap = {
      'Personal Information': 'icon-ic-personal-info',
      'Profile Picture': `icon-ic-profile-picture`,
      Headline: `icon-ic-headline`,
      Summary: `icon-ic-summary`,
      Experience: `icon-ic-experience`,
      Education: `icon-ic-education`,
    }
  }

  componentDidMount() {
    const { sectionName } = this.props
    this.setState({
      currentLogSection: sectionName,
    })
    window.addEventListener('resize', this.handleScreenResize)
    let modalElement = document.getElementsByClassName('logs-modal')
    if (modalElement.length > 0) {
      setTimeout(() => {
        modalElement[0].style.paddingLeft = '0px'
      }, 10)
    }
  }

  downloadImage(url) {
    const { downloadImage, intl } = this.props
    downloadImage(url, intl)
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleScreenResize)
  }

  getLocalizedMonth(monthNum, intl) {
    const key = this.monthKeyMap[monthNum];
    if (!key) return this.month[monthNum] || monthNum;
    const translated = intl.formatMessage({ id: key });
    if (!translated || translated === key) {
      return this.month[monthNum] || monthNum;
    }
    return translated;
  }

  getDate(date) {
    date = moment.utc(date).format('YYYY-MM-DD HH:mm:ss')
    var stillUtc = moment.utc(date).toDate()
    var local = moment(stillUtc).local().format('YYYY-MM-DD HH:mm:ss')
    let d = local.split(/[-:\s]/)
    const monthStr = this.getLocalizedMonth(d[1], this.props.intl);
    return (
      monthStr +
      ' ' +
      d[2] +
      ', ' +
      d[0] +
      ' ' +
      d[3] +
      ':' +
      d[4] +
      ':' +
      d[5]
    )
  }

  splitParagraphs(text, sectionName) {
    let temp = []
    let splits = text.split('\n')

    for (let k in splits) {
      temp.push(<div key={k + '-' + sectionName}>{splits[k]}</div>)
    }

    return temp
  }

  handleClick(e, currentSectionName, currentLogIndex, data, subSectionUid) {
    const {
      fetchId,
      logs,
      prevData,
      feedback,
      processEditedData,
      processingStatus,
      intl,
    } = this.props

    const { currentLogSection } = this.state

    if (processingStatus == 'processing' || _.isNull(processingStatus)) return

    let score =
      feedback[currentLogSection]['section_score'][currentLogIndex]['score']

    let jsonObjectForTracking = {
      eventLabel: 'revert_button',
      fetchId: fetchId,
      sectionName: currentSectionName,
      currentIndex: currentLogIndex,
    }

    this.sendTrackingDataDebounce(
      'event',
      'aspire_log_modal',
      'click',
      JSON.stringify(jsonObjectForTracking)
    )
    let countSections = _.size(prevData[this.sectionUnderscore[currentSectionName]])
    processEditedData(
      fetchId,
      currentSectionName,
      currentLogIndex,
      countSections,
      false,
      data,
      subSectionUid,
      prevData[this.sectionUnderscore[currentSectionName]][currentLogIndex],
      score,
      false,
      false,
      intl
    )
  }

  fetchImageUrl(url) {
    if (_.isEmpty(url)) {
      // replace by condition to check if invalid
      return false
    }

    return url
  }

  compareDatesInLogObject(a, b) {
    const aCreatedDate = new Date(a.date)
    const bCreatedDate = new Date(b.date)
    if (aCreatedDate.getTime() < bCreatedDate.getTime()) return 1
    if (aCreatedDate.getTime() > bCreatedDate.getTime()) return -1
    return 0
  }

  handleNavClick(e, section) {
    this.setState({
      currentLogSection: section,
    })
  }

  handleScreenResize() {
    let modalElement = document.getElementsByClassName('logs-modal')
    if (modalElement.length == 1) {
      modalElement[0].style.paddingLeft = '0px'
    } else if (modalElement.length == 2) {
      modalElement[0].style.paddingLeft = '0px'
      modalElement[1].style.paddingLeft = '0px'
    }
  }

  getSectionDisplayName(section, intl) {
    const sectionMap = {
      'Profile Picture': { id: 'aspire.logscreenNames.profilePicture', defaultMessage: 'Profile Picture' },
      'Personal Information': { id: 'aspire.logscreenNames.personalInformation', defaultMessage: 'Personal Information' },
      'Headline': { id: 'aspire.logscreenNames.headline', defaultMessage: 'Headline' },
      'Summary': { id: 'aspire.logscreenNames.summary', defaultMessage: 'About' },
      'Experience': { id: 'aspire.logscreenNames.experience', defaultMessage: 'Experience' },
      'Education': { id: 'aspire.logscreenNames.education', defaultMessage: 'Education' },
    };
    const msg = sectionMap[section];
    return msg
      ? intl.formatMessage({ id: msg.id, defaultMessage: msg.defaultMessage })
      : section;
  }

  render() {
    const {
      show,
      sectionName,
      currentIndex,
      logs,
      showLogModal,
      hideLogModal,
      processingStatus,
      intl,
    } = this.props

    const { currentLogSection } = this.state

    let logArrayData = []
    let allLogsArray = []
    let noLogs = false

    if (currentLogSection in logs) {
      _.map(logs[currentLogSection], (log, index) => {
        _.map(log, (logRow) => {
          logArrayData.push({ ...logRow, subSectionId: index })
        })
      })
    } else {
      noLogs = true
    }

    let sortedLogArray = logArrayData.sort(this.compareDatesInLogObject)

    for (let i in sortedLogArray) {
      let logArray = []
      let scoreChange = []
      if (sortedLogArray[i]['score_change'] == 1) {
        scoreChange.push(
          <div className="score-change-ind text-green">
            <span className="score-change-ind-img">
              <img
                alt={intl.formatMessage({ id: "aspire.logScreen.scoreImproved", defaultMessage: "Score improved from this version" })}
                src={`${process.env.APP_BASE_URL}dist/images/ic_scoreimproved.svg`}
                height="13"
              />
            </span>{' '}
            <FormattedMessage id="aspire.logScreen.scoreImproved" defaultMessage="Score improved from this version" />
          </div>
        )
      } else if (sortedLogArray[i]['score_change'] == -1) {
        scoreChange.push(
          <div className="score-change-ind text-red">
            <span className="score-change-ind-img">
              <img
                alt={intl.formatMessage({ id: "aspire.logScreen.scoreDecreased", defaultMessage: "Score decreased from this version" })}
                src={`${process.env.APP_BASE_URL}dist/images/ic_scoredecreased.svg`}
                height="13"
              />
            </span>{' '}
            <FormattedMessage id="aspire.logScreen.scoreDecreased" defaultMessage="Score decreased from this version" />
          </div>
        )
      } else if (sortedLogArray[i]['score_change'] == 0) {
        scoreChange.push(
          <div className="score-change-ind" style={{ color: '#666' }}>
            <FormattedMessage id="aspire.logScreen.noImprovement" defaultMessage="No improvement from this version" />
          </div>
        )
      } else if (sortedLogArray[i]['score_change'] == 2) {
        scoreChange.push(<div className="score-change-ind" />)
      }

      logArray.push(
        <div className="log-single-entry">
          <div
            tabIndex={0}
            role="region"
            aria-label={intl.formatMessage(
              {
                id: "aspire.logScreen.ariaSavedOn",
                defaultMessage: "Saved on {date} {scoreChangetext}"
              },
              {
                date: this.getDate(sortedLogArray[i]['date']),
                scoreChangetext: logModalAriaLabel(intl)[sortedLogArray[i]['score_change']]
              }
            )}
            className="">
            <span className="log-single-entry-time">
              {' '}
              <FormattedMessage
                id="aspire.logScreen.savedOn"
                defaultMessage="Saved on {date}"
                values={{ date: this.getDate(sortedLogArray[i]['date']) }}
              />
            </span>
            <span className="log-single-entry-undo undo-text float-end">
              <a
                aria-label={logModalAriaLabel(intl)['revert']}
                href="javascript:void(0);"
                onClick={(e) => {
                  if (!sortedLogArray[i].subSectionId.startsWith('deleted')) {
                    this.handleClick(
                      e,
                      currentLogSection,
                      sortedLogArray[i].subSectionId,
                      sortedLogArray[i].data,
                      sortedLogArray[i].sub_section_uid
                    )
                  }
                }}
                className={
                  processingStatus == 'processing' ||
                  _.isNull(processingStatus) ||
                  sortedLogArray[i].subSectionId.startsWith('deleted')
                    ? 'light-gray-txt revert-log'
                    : 'text-blue revert-log'
                }
                data-id={i}>
                {!sortedLogArray[i].subSectionId.startsWith('deleted') ? (
                  <>
                    <img
                      alt=""
                      src={`${
                        processingStatus == 'processing' ||
                        _.isNull(processingStatus)
                          ? process.env.APP_BASE_URL +
                            'dist/images/revert-disable.svg'
                          : process.env.APP_BASE_URL +
                            'dist/images/ic_revert_version.svg'
                      }`}
                      className="log-revert-img"
                      width="16px"
                    />{' '}
                    <span>
                      <FormattedMessage id="aspire.logScreen.revertText" defaultMessage="Revert to this version" />
                    </span>
                  </>
                ) : (
                  <span>
                    <FormattedMessage id="aspire.logScreen.deletedText" defaultMessage="Deleted" />
                  </span>
                )}
              </a>
            </span>
          </div>
          {scoreChange}
        </div>
      )

      logArray.push(<div className="clearfix" />)

      let data = []

      if (currentLogSection == 'Personal Information') {
        data.push(
          <div className="logs-pi-name">
            {sortedLogArray[i]['render_text']['name']}
          </div>
        )
        data.push(
          <div className="logs-pi-url">
            {sortedLogArray[i]['render_text']['profile_url']}
          </div>
        )
      } else if (currentLogSection == 'Profile Picture') {
        let url = this.fetchImageUrl(
          sortedLogArray[i]['render_text']['picture_url']
        )

        if (url != false) {
          data.push(
            <div className="edit-img-section">
              <div className="download-photo-container">
                <img
                  alt={intl.formatMessage({ id: "aspire.logScreen.downloadButton", defaultMessage: "Download Button" })}
                  src={`${process.env.APP_BASE_URL}dist/images/ic_download.svg`}
                  className="download-button"
                  onClick={() => {
                    this.downloadImage(url)
                  }}
                />
              </div>
              <div className="edit-img">
                {' '}
                <img alt="Profile Image" src={url} className="log-edit-img" />{' '}
              </div>
            </div>
          )
        }
      } else if (
        currentLogSection == 'Headline' ||
        currentLogSection == 'Summary'
      ) {
        data = (
          <div className="logs-headline-text">
            {this.splitParagraphs(
              sortedLogArray[i]['render_text'],
              currentLogSection
            )}
          </div>
        )
      } else if (
        currentLogSection == 'Experience' ||
        currentLogSection == 'Education' ||
        currentLogSection == 'Volunteer Experience' ||
        currentLogSection == 'Projects' ||
        currentLogSection == 'Publications'
      ) {
        if (!_.isEmpty(sortedLogArray[i]['render_text']['title'])) {
          data.push(
            <div className="p-heading-1">
              {sortedLogArray[i]['render_text']['title']}
            </div>
          )
        }

        if (!_.isEmpty(sortedLogArray[i]['render_text']['sub_title'])) {
          for (let j in sortedLogArray[i]['render_text']['sub_title']) {
            const subTitle = sortedLogArray[i]['render_text']['sub_title'][j];
            let renderedSubTitle = subTitle;
            if (currentLogSection == 'Experience') {
              const dateRangeRegex = /^([A-Za-z]{3,}) (\d{4})\s*-\s*(?:(Present)|([A-Za-z]{3}) (\d{4}))$/;
              const match = subTitle.match(dateRangeRegex);
              if (match) {
                const [ , startMonth, startYear, present, endMonth, endYear ] = match;
                const monthMap = {
                  Jan: 'aspire.months.jan',
                  Feb: 'aspire.months.feb',
                  Mar: 'aspire.months.mar',
                  Apr: 'aspire.months.apr',
                  May: 'aspire.months.may',
                  Jun: 'aspire.months.jun',
                  Jul: 'aspire.months.jul',
                  Aug: 'aspire.months.aug',
                  Sep: 'aspire.months.sep',
                  Oct: 'aspire.months.oct',
                  Nov: 'aspire.months.nov',
                  Dec: 'aspire.months.dec',
                  Present: 'aspire.logscreen.present'
                };
                const startMonthLabel = monthMap[startMonth]
                  ? this.props.intl.formatMessage({ id: monthMap[startMonth], defaultMessage: startMonth })
                  : startMonth;
                if (present === 'Present') {
                  renderedSubTitle = `${startMonthLabel} ${startYear} - ${this.props.intl.formatMessage({ id: monthMap['Present'], defaultMessage: 'Present' })}`;
                } else if (endMonth && endYear) {
                  const endMonthLabel = monthMap[endMonth]
                    ? this.props.intl.formatMessage({ id: monthMap[endMonth], defaultMessage: endMonth })
                    : endMonth;
                  renderedSubTitle = `${startMonthLabel} ${startYear} - ${endMonthLabel} ${endYear}`;
                } else {
                  renderedSubTitle = subTitle;
                }
              } else {
                renderedSubTitle = subTitle;
              }
            }
            data.push(
              <div className="p-heading-2">
                {renderedSubTitle}
              </div>
            )
          }
        }

        if (!_.isEmpty(sortedLogArray[i]['render_text']['text'])) {
          let temp = this.splitParagraphs(
            sortedLogArray[i]['render_text']['text'],
            currentLogSection
          )
          data.push(<div className="logs-exp-text">{temp}</div>)
        }
      }
      if (!_.isEmpty(data)) {
        logArray.push(<div className="width100 f-edit input-log">{data}</div>)
      }
      let indLogArray = <div className="as-logs-desc-row">{logArray}</div>
      allLogsArray.push(indLogArray)
    }

    let liNavs = []
    let sections = [
      'Profile Picture',
      'Personal Information',
      'Headline',
      'Summary',
      'Experience',
      'Education',
    ]

    for (let i in sections) {
      let logsCount = 0
      if (sections[i] in logs) {
        _.mapObject(logs[sections[i]], (value, index) => {
          logsCount = logsCount + value.length
        })
      }

      liNavs.push(
        <li
          key={i}
          id={`section-logs-${i}`}
          role="tab"
          className={classNames('section-logs-nav-col', {
            active: currentLogSection == sections[i],
          })}
          aria-selected={currentLogSection == sections[i]}>
          <a
            aria-label={intl.formatMessage(
              { id: "aspire.logScreen.sectionNavAria", defaultMessage: "Click to see logs of {section}" },
              { section: sections[i] }
            )}
            onClick={(e) => this.handleNavClick(e, sections[i])}
            data-navindex={i}
            data-bs-toggle="tab"
            className="section-logs-nav-li">
            <div
              className={`${
                this.leftNavIconsMap[sections[i]]
              } section-logs-nav-li-icon-div`}></div>
            {this.getSectionDisplayName(sections[i], intl)}
            <div className="as-logs-section-count">{logsCount}</div>
          </a>
        </li>
      )
    }

    setTimeout(() => {
      let modalElement = document.getElementsByClassName('logs-modal')
      if (modalElement.length == 1) {
        modalElement[0].style.paddingLeft = '0px'
      } else if (modalElement.length == 2) {
        modalElement[0].style.paddingLeft = '0px'
        modalElement[1].style.paddingLeft = '0px'
      }
    }, 10)
    let title = `${ currentLogSection }`
    title = this.getSectionDisplayName(title, intl)

    return (
      <div
        role="dialog"
        aria-label={intl.formatMessage({ id: "aspire.logScreen.dialogAria", defaultMessage: "Log of edits made in this session" })}
        aria-modal={true}>
        <FocusLock disabled={!show} returnFocus={true}>
          <Modal
            className="profile-picture-edit-modal logs-modal"
            isOpen={show}
            onRequestHide={hideLogModal}>
            <ModalBody>
              <div className="as-edit-wrapper as-logs-wrapper">
                <div className="as-logs-close-div">
                  <a
                    tabIndex={0}
                    href="javascript:void(0);"
                    className="icon-cross as-logs-close-btn modal-close-button"
                    onClick={hideLogModal}
                    aria-label={intl.formatMessage({ id: "aspire.logScreen.closeAria", defaultMessage: "Click to close the log modal" })}
                  />
                </div>
                <div className="as-logs-heading-wrapper">
                  <div className="as-logs-heading">
                    <FormattedMessage
                      id="aspire.logScreen.editHistoryHeading"
                      defaultMessage="{section} Edit History"
                      values={{ section: title }}
                    />
                  </div>
                </div>
                <div className="as-logs-container" id="vertical-scroll">
                  <div className="row as-logs-row">
                    <div className="col-sm-3 as-logs-nav">
                      <ul
                        className="nav nav-tabs"
                        id="parameters-navigation-tab-log"
                        role="tablist"
                        tabIndex={0}>
                        {liNavs}
                      </ul>
                    </div>
                    <div className="col-sm-9 as-logs-main-container">
                      {!_.isEmpty(allLogsArray) ? (
                        <>
                          <div className="as-logs-current-heading">
                            {title}
                          </div>
                          <div className="as-logs-log-desc-div">
                            {allLogsArray}
                          </div>
                        </>
                      ) : (
                        <div className="as-logs-empty-div" tabIndex={0}>
                          <img
                            alt=""
                            src={`${process.env.APP_BASE_URL}dist/images/info_empty_log.svg`}
                            className="as-logs-empty-icon"
                          />
                          <div className="as-logs-empty-text">
                            <FormattedMessage id="aspire.logScreen.noEdits" defaultMessage="No Previous Edits!" />
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </ModalBody>
          </Modal>
        </FocusLock>
      </div>
    )
  }
}

function mapStateToProps(state, ownProps) {
  return {
    processingStatus: state.aspireFeedbackData.status,
    loaderInput: state.aspireFeedbackData.mini_loader_text,
  }
}

export default connect(mapStateToProps, { processEditedData, downloadImage })(
  injectIntl(LogScreen)
)
